import PropTypes from 'prop-types';
import { UITitleLineShape, UITextLineShape } from '../../HomeFeedUILines/shared/proptypes';

export const PlaceholderCardShape = {
  isPlaceholder: PropTypes.bool.isRequired,
  withAnimation: PropTypes.bool.isRequired,
};

const UIContentShape = {
  uiLines: PropTypes.arrayOf(
    PropTypes.shape({
      typeName: PropTypes.string.isRequired,
      ...UITitleLineShape,
      ...UITextLineShape,
    }),
  ),
  bubble: PropTypes.shape({
    qualifier: PropTypes.string,
    qualifierPosition: PropTypes.string,
    text: PropTypes.string,
  }),
  image: PropTypes.string.isRequired,
};

const POSITION_ENUMS = [
  'MIDDLE',
  'TOP_LEADING',
  'TOP_TRAILING',
  'BOTTOM_LEADING',
  'BOTTOM_TRAILING',
];

export const UIOverlayShape = {
  overlay: PropTypes.shape({
    backgroundColor: PropTypes.shape({
      r: PropTypes.number.isRequired,
      g: PropTypes.number.isRequired,
      b: PropTypes.number.isRequired,
      a: PropTypes.number.isRequired,
    }),
    text: PropTypes.shape({
      color: PropTypes.shape({
        hex: PropTypes.string.isRequired,
      }).isRequired,
      value: PropTypes.string.isRequired,
      position: PropTypes.oneOf(POSITION_ENUMS).isRequired,
    }),
    image: PropTypes.shape({
      url: PropTypes.string.isRequired,
      position: PropTypes.oneOf(POSITION_ENUMS).isRequired,
    }),
    badge: PropTypes.shape({
      color: PropTypes.shape({
        hex: PropTypes.string.isRequired,
      }).isRequired,
      text: PropTypes.arrayOf(
        PropTypes.shape({
          typeName: PropTypes.string.isRequired,
          ...UITitleLineShape,
          ...UITextLineShape,
        }),
      ),
      position: PropTypes.oneOf(POSITION_ENUMS).isRequired,
    }),
  }),
};

export const UICardContentShape = {
  ...UIContentShape,
  ...UIOverlayShape,
  url: PropTypes.string,
  isPlaceholder: PropTypes.bool,
  placeholderClass: PropTypes.string,
  onClick: PropTypes.func,
  preLoad: PropTypes.bool,
  contentSize: PropTypes.string,
  lazyLoadImage: PropTypes.bool,
};

export default UIContentShape;
